import { render } from "./kpisIndicators.vue?vue&type=template&id=965b1ba2"
import script from "./kpisIndicators.vue?vue&type=script&lang=js"
export * from "./kpisIndicators.vue?vue&type=script&lang=js"

import "./kpisIndicators.vue?vue&type=style&index=0&id=965b1ba2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__